import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IoClose } from 'src/components/common/Icons';
import { envStrToBoolean } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { MediaManager } from 'src/manager/MediaManager';
import { openMyAccountModal } from 'src/store/account-modal/actions';
import { RootState } from 'src/types/store-types';
import GameBoxSearch from './GameBoxSearch';
import './styles.scss';

interface IGameBoxHeaderProps {
  onClose: () => void;
}

const GameBoxHeader: FC<IGameBoxHeaderProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { game } = useSelector((state: RootState) => state.games);
  const { user } = useSelector((state: RootState) => state.user);
  const _openAccountModal = useConnectedAction(openMyAccountModal);

  const logoUrl = MediaManager.getSrcFromMediaAssets('logo.png', '/');

  const gameName = game?.name || game?.gameName || '';
  const providerName = game?.provider || game?.providerName || '';
  const gameInfo = gameName && providerName ? `${gameName} - ${providerName}` : gameName || providerName || '';

  const nickname = user?.nickname || user?.username || '';
  const showDepositBtn = envStrToBoolean(process.env.REACT_APP_SHOW_INGAME_DEPOSIT_BTN);

  const handleDeposit = (): void => {
    _openAccountModal({ section: 'deposit', subSection: 'deposit' });
  };

  return (
    <div className="gamebox-header">
      <div className="gamebox-header__left">
        <img src={logoUrl} alt="Logo" className="gamebox-header__logo" />
        {gameInfo && <span className="gamebox-header__game-info">{gameInfo}</span>}
      </div>
      <div className="gamebox-header__right">
        <GameBoxSearch />
        {nickname && <span className="gamebox-header__nickname">{nickname}</span>}
        {showDepositBtn && (
          <button className="gamebox-header__deposit-btn" onClick={handleDeposit}>
            {t('deposit')}
          </button>
        )}
        <button className="gamebox-header__close-btn" onClick={onClose} aria-label="Close game">
          <IoClose size={24} />
        </button>
      </div>
    </div>
  );
};

export default GameBoxHeader;
